import { __awaiter, __generator } from "tslib";
import { DocumentData, DocumentStatus, PadInfo, DocumentEntity, DOCUMENT_TYPE_DESC_MAP } from '@tencent/ark-model';
import { DocumentDataStorage, DocumentEntityStorage, DocumentStatusStorage, PadInfoStorage } from '@tencent/ark-storage';
import { TransactionMode } from '@tencent/memoire-structured-storage';
import { LoggerProxy } from '../logger/logger-proxy';
var AbstractDocumentDataUpdater = /** @class */ (function () {
    function AbstractDocumentDataUpdater() {
    }
    Object.defineProperty(AbstractDocumentDataUpdater.prototype, "updateDocumentData", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (response, config, storageManager) {
            return __awaiter(this, void 0, void 0, function () {
                var documentData, isManualOffline, mainDocumentData, secretId, globalPadId, dataVersion, docType, param, documentEntities, documentEntityCollection, documentEntityStorage;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            LoggerProxy.info(AbstractDocumentDataUpdater.logTag, '开始更新文档已落盘数据');
                            documentData = response.documentData, isManualOffline = response.isManualOffline;
                            mainDocumentData = documentData[0];
                            secretId = mainDocumentData.secretId, globalPadId = mainDocumentData.globalPadId, dataVersion = mainDocumentData.dataVersion, docType = mainDocumentData.docType;
                            param = {
                                config: config,
                                docType: docType,
                                secretId: secretId,
                                globalPadId: globalPadId,
                                dataVersion: dataVersion,
                            };
                            return [4 /*yield*/, storageManager.storage.transaction([PadInfo, DocumentData], TransactionMode.READ_WRITE, function (transaction) { return __awaiter(_this, void 0, void 0, function () {
                                    var uid, documentDataCollection, documentDataStorage, padInfoCollection, padInfoStorage, padInfo;
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                uid = config.user.uid;
                                                documentDataCollection = transaction.collection(DocumentData);
                                                documentDataStorage = new DocumentDataStorage(documentDataCollection);
                                                // 1. 删除存量的已落盘的记录
                                                return [4 /*yield*/, documentDataStorage.deleteChanges({ uid: uid, secretId: secretId })];
                                            case 1:
                                                // 1. 删除存量的已落盘的记录
                                                _a.sent();
                                                // 2. 写入新的已落盘的记录
                                                return [4 /*yield*/, documentDataStorage.upsertChanges(documentData)];
                                            case 2:
                                                // 2. 写入新的已落盘的记录
                                                _a.sent();
                                                padInfoCollection = transaction.collection(PadInfo);
                                                padInfoStorage = new PadInfoStorage(padInfoCollection);
                                                return [4 /*yield*/, padInfoStorage.updateField(uid, secretId, {
                                                        dver: dataVersion,
                                                        isOfflineCache: true,
                                                    })];
                                            case 3:
                                                _a.sent();
                                                return [4 /*yield*/, padInfoStorage.getPadInfo(uid, secretId)];
                                            case 4:
                                                padInfo = _a.sent();
                                                LoggerProxy.info(AbstractDocumentDataUpdater.logTag, "\u66F4\u65B0\u6570\u636E\u5E93\u4E2D\u7684\u6587\u6863\u5DF2\u843D\u76D8\u6570\u636E, secretId = ".concat(secretId, " padInfo").concat(padInfo));
                                                return [2 /*return*/];
                                        }
                                    });
                                }); })];
                        case 1:
                            _a.sent();
                            documentEntities = this.buildDocumentEntities(response, param);
                            if (!((documentEntities === null || documentEntities === void 0 ? void 0 : documentEntities.length) > 0)) return [3 /*break*/, 3];
                            documentEntityCollection = storageManager.storage.collection(DocumentEntity);
                            documentEntityStorage = new DocumentEntityStorage(documentEntityCollection);
                            return [4 /*yield*/, documentEntityStorage.upsertEntities(documentEntities)];
                        case 2:
                            _a.sent();
                            LoggerProxy.info(AbstractDocumentDataUpdater.logTag, "\u66F4\u65B0\u6587\u6863\u7684 Entity \u6269\u5C55\u6570\u636E, secretId = ".concat(secretId));
                            _a.label = 3;
                        case 3:
                            if (!isManualOffline) return [3 /*break*/, 5];
                            return [4 /*yield*/, this.cacheImage(response, param)];
                        case 4:
                            _a.sent();
                            _a.label = 5;
                        case 5: 
                        // 6. 更新文档的最新更新时间
                        return [4 /*yield*/, this.updateDocumentStatus(param, storageManager)];
                        case 6:
                            // 6. 更新文档的最新更新时间
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        }
    });
    Object.defineProperty(AbstractDocumentDataUpdater.prototype, "cacheImage", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (response, param) {
            var _a, _b;
            return __awaiter(this, void 0, void 0, function () {
                var imageUrls, imageRequest, docTypeDesc;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0: return [4 /*yield*/, this.getImageUrls(response, param)];
                        case 1:
                            imageUrls = _c.sent();
                            if (imageUrls.length === 0) {
                                LoggerProxy.info(AbstractDocumentDataUpdater.logTag, "\u6CA1\u6709\u9700\u8981\u7F13\u5B58\u7684\u56FE\u7247\u6570\u636E\uFF0Csecretid = ".concat(param.secretId));
                                return [2 /*return*/];
                            }
                            imageRequest = imageUrls.map(function (url) { return ({ url: url, method: 'get' }); });
                            LoggerProxy.info(AbstractDocumentDataUpdater.logTag, '开始缓存图片数据 =', imageRequest);
                            docTypeDesc = DOCUMENT_TYPE_DESC_MAP[param.docType];
                            (_b = (_a = global.tdocs) === null || _a === void 0 ? void 0 : _a.manualSaveDocData) === null || _b === void 0 ? void 0 : _b.call(_a, {
                                docUrl: "".concat(global.location.protocol, "://").concat(global.location.hostname, "/").concat(docTypeDesc, "/").concat(param.secretId),
                                request: { image: imageRequest },
                            });
                            return [2 /*return*/];
                    }
                });
            });
        }
    });
    Object.defineProperty(AbstractDocumentDataUpdater.prototype, "updateDocumentStatus", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (param, storageManager) {
            return __awaiter(this, void 0, void 0, function () {
                var globalPadId, secretId, config, documentStatusCollection, documentStatusStorage, documentStatus;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            LoggerProxy.info(AbstractDocumentDataUpdater.logTag, '更新文档的状态信息, param = ', param);
                            globalPadId = param.globalPadId, secretId = param.secretId, config = param.config;
                            documentStatusCollection = storageManager.storage.collection(DocumentStatus);
                            documentStatusStorage = new DocumentStatusStorage(documentStatusCollection);
                            documentStatus = new DocumentStatus();
                            documentStatus.uid = config.user.uid;
                            documentStatus.secretId = secretId;
                            documentStatus.globalPadId = globalPadId;
                            documentStatus.lastSyncTimestamp = Date.now();
                            return [4 /*yield*/, documentStatusStorage.upsertStatus(documentStatus)];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        }
    });
    Object.defineProperty(AbstractDocumentDataUpdater, "logTag", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 'AbstractDocumentDataUpdater'
    });
    return AbstractDocumentDataUpdater;
}());
export { AbstractDocumentDataUpdater };
